module.exports = __webpack_public_path__ + "img/spotify-icon.913eab21.svg";